import React, { Component } from "react";
import Button from "../../Button/Button";

class PlanSettingsBlock extends Component {
	render() {
		let noInfo = "N/A";
		return (
			<div className="account-info-block">
				<h2>Plan Settings</h2>
				<div className="account-info-col-container">
					<div className="account-info-l">
						<p className="account-info-label">Current Plan</p>
					</div>
					<div className="account-info-r">
						<p className="account-info-text">
							{this.props.info["currentPlan"].length > 0
								? this.props.info["currentPlan"].join(", ").replace("recommend_acquiror", "Recommend Acquirers").replace("find_company_app", "Screen Targets")
								: noInfo}
						</p>
					</div>
				</div>
				<Button
					label="Edit Plan"
					onClick={() =>
						this.props.changeLocation("/dashboard/account/edit-plan")}
				/>
			</div>
		);
	}
}

export default PlanSettingsBlock;


// WEBPACK FOOTER //
// ./src/components/Account/PlanSettingsBlock/PlanSettingsBlock.js